import {BehaviorSubject, Observable, Subject} from "rxjs";
import {EquityWizardData} from "../../place-equity-order-wizard/models/EquityWizardData";

export class MultiOrderStore {
    private _orders: BehaviorSubject<EquityWizardData[]> = new BehaviorSubject([]);
    private _selectedOrder: BehaviorSubject<EquityWizardData | null> = new BehaviorSubject(null);
    private _destroy$ = new Subject<void>();

    get orders$(): Observable<EquityWizardData[]> {
        return this._orders.asObservable().takeUntil(this._destroy$);
    }

    get selectedOrder$(): Observable<EquityWizardData | null> {
        return this._selectedOrder.asObservable().takeUntil(this._destroy$);
    }

    public addOrder(order: EquityWizardData) {
        const currentOrders = this._orders.getValue();
        const newOrders = [...currentOrders, order];
        this._orders.next(newOrders);
    }

    public updateOrder(index: number, updatedOrder: EquityWizardData) {
        const currentOrders = this._orders.getValue();
        const newOrders = [...currentOrders];
        newOrders[index] = updatedOrder;
        this._orders.next(newOrders);
    }

    public removeOrder(index: number) {
        const currentOrders = this._orders.getValue();
        const newOrders = [...currentOrders];
        newOrders.splice(index, 1);
        this._orders.next(newOrders);
    }

    public selectOrder(order: EquityWizardData) {
        this._selectedOrder.next(order);
    }

    public clearSelectedOrder() {
        this._selectedOrder.next(null);
    }

    public destroy() {
        this._destroy$.next();
        this._destroy$.complete();
        this._orders.complete();
        this._selectedOrder.complete();
    }
}